Vue.component('playingCard', {
  template: templates.playingCard,
  props: ['card', 'show'],
  data() {
    return {
      model: {
        show: false,
        timer: null,
        cooldown: this.card.cooldown,
      }
    }
  },
  mounted() {
    const c = this;

    if (c.show) {
      c.model.show = true;
    }

    c.$root.$on(`flip${this.card.id}`, id => {
      c.flip(id);
    });

    if (c.card.cooldown) {
      c.timer();
    }
  },
  watch: {
    card: function() {
      const c = this;

      c.model.timer = null;
      
      if (c.card.cooldown) {
        clearInterval(c.model.timer);
        c.timer();
      }
    }
  },
  methods: {
    timer() { 
      const c = this;

      let seconds = Math.round(c.card.cooldown * 60);

      c.model.timer = setInterval(function() {
        seconds -= 1;

        if (seconds > -1) {
          c.card.cooldown = c.format(seconds);
        } else {
          c.card.cooldown = null;
          clearInterval(c.model.timer);
        }

      }, 1000);

    },
    format(time) {
      // Hours, minutes and seconds
      var hrs = ~~(time / 3600);
      var mins = ~~((time % 3600) / 60);
      var secs = ~~time % 60;

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = "";
      if (hrs > 0) {
          ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
      }
      ret += "" + mins + ":" + (secs < 10 ? "0" : "");
      ret += "" + secs;
      return ret;
    },
    flip(id) {
      if (id) {
        const c = this;
        
        const $card = $(`[data-id="${id}"] .playing-card:visible`);
        //$card.addClass('playing-card--flipped');

        // if($card.hasClass('flipped')) {
        //   $card.addClass('unflip');
        //   setTimeout(function(){
        //     $card.removeClass('flipped').removeClass('unflip');
        //   }, 500);
        // }
        // else { 
          $card.addClass('flipped');
        // }
      }
    },
    select(card) {
      //card.selected = card.selected ? false : true;
    }
  }
});